<div class="offer-card card">

    <div class="asset-card--header">
        {{transaction.product_name}}
        <aihub-context-menu class="context-menu" card-context-menu [align]="'right'"
            *ngIf="transaction.state === transactionState.DECLINED">
            <ul class="list-group" aihubContextMenuBody>
                <li aihubContextMenuItem (click)="triggerAction(cardAction.DELETE_CARD)"
                    [ngClass]="'list-group-item list-group-item-action'">
                    {{'DELOITTEAI.CARD.OFFER.BUYER.DELETE' | translate}}
                </li>
            </ul>
        </aihub-context-menu>
    </div>

    <div class="asset-card--body">

        <dl>
            <!-- status badget -->
            <dt>Status</dt>
            <dd>
                <span class="badge" [ngClass]="'badge--' + transaction.state.toLowerCase()">
                    {{'DELOITTEAI.CARD.OFFER.BUYER.STATE.' + transaction.state.toUpperCase() | translate}}
                </span>
            </dd>

            <!-- plan -->
            <dt>{{'DELOITTEAI.CARD.OFFER.PLAN' | translate}}</dt>
            <dd>{{transaction.plan.name}}</dd>

            <!-- contact -->
            <dt>{{'DELOITTEAI.CARD.OFFER.BUYER.CONTACT' | translate}}</dt>
            <dd>{{transaction.asset_owner}}</dd>
        </dl>

    </div>

    <div class="asset-card--footer" *ngIf="transaction.state === transactionState.PROPOSED">
        <button class="btn btn-primary" (click)="triggerAction(cardAction.SHOW_CONTRACT)">
            {{'DELOITTEAI.CARD.OFFER.BUYER.CTA.' + transaction.state.toUpperCase() | translate}}
        </button>
    </div>

</div>